// extracted by mini-css-extract-plugin
export var card = "_74-0";
export var failedIcon = "_74-4";
export var failedIconBadge = "_74-3";
export var icon = "_74-1";
export var successIcon = "_74-2";